import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../reducer/CombineReducer";
import { INotification } from "../../Notification/Index";
import { useUser } from "../../../AuthContext";
import { IListItem } from "../../Common/UI/Index";
import ExractAddView from "./ExtractAdd.view";
import { ExtractOnSubmitProps } from "./IExtractCreateOrUpdateProps";
import { onSubmit } from "./script";

/**
 * Internal type for title validation
 */
export interface ITitleValidationInfo {
  isInvalid: boolean;
  validationText: string;
}

export interface IExtractAddProp {

  /**
   * Close call back 
   */
  onClose: () => void;

  /**
   * Data Values for year range dropdown
   */
  yearsDataValue: IListItem[];

  /**
   * Flag to toggle Add/Edit view
   */
  isEdit?: boolean;

  /**
   * To Show notification
   */
  notification: INotification;
}

type Props = IExtractAddProp;

/**
 * Responsible for rendering Create Extract component
 */
const ExtractAdd = (props: Props): JSX.Element => {
  const { onClose, yearsDataValue, isEdit, notification } = props;
  const [
    extractAdd,
    yearsState,
    extractState
  ] = useSelector((state: IRootState) => [
    state.extractAdd,
    state.yearsState,
    state.extractState
  ], shallowEqual);
  const dispatch = useDispatch();
  const { user } = useUser();
  const year = yearsState.selectedYear;
  const mode = extractAdd.mode;
  const { t: translate } = useTranslation();

  const details: ExtractOnSubmitProps = {
    extractAdd,
    year,
    notification,
    user,
    translate,
    mode,
    extractState,
    onClose
  };

  const onClick = (): void => {
    onSubmit(dispatch, details);
  };

  return (
    <ExractAddView
      isEdit={isEdit}
      onClose={onClose}
      yearsDataValue={yearsDataValue}
      newExtract = {extractAdd.newExtract}
      onSubmit={onClick}
    />);
};

export default ExtractAdd;
